// ModalWithTextStyles.ts
import { makeStyles, Theme, createStyles } from "@material-ui/core";

const useModalWithTextStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogContent: {
      maxHeight: "70vh",
      overflowY: "auto",
    },
    title: {
      color: "#A61C14",
      fontSize: 24,
      fontWeight: 600,
    },
    paragraph: {
      marginTop: theme.spacing(2),
      fontSize: 20,
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
      lineHeight: 1.6,
      color: "#403F3F",
    },
  })
);

export default useModalWithTextStyles;
